export class DisconnectSourceAccountResponse {
    'sourceAccount';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sourceAccount",
            "baseName": "sourceAccount",
            "type": "SourceAccount",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DisconnectSourceAccountResponse.attributeTypeMap;
    }
    constructor() {
    }
}
